import React from "react";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import { getContentString } from "./chatUtils";
import MarkdownRenderer from "./MarkdownRenderer";
import ToolCallDisplay from "./ToolCallDisplay";
import useIsMobile from "../../hooks/useIsMobile";

const AssistantMessageBubble = ({ message, feedback, onFeedback }) => {
  const isMobile = useIsMobile();
  const text = getContentString(message);
  const toolCalls = message?.tool_calls;
  const hasContent = text || (toolCalls && toolCalls.length > 0);

  if (!hasContent) return null;

  const ThumbUp = feedback === "up" ? ThumbUpIcon : ThumbUpOutlinedIcon;
  const ThumbDown = feedback === "down" ? ThumbDownIcon : ThumbDownOutlinedIcon;

  return (
    <div style={{ display: "flex", gap: isMobile ? "0px" : "10px", marginBottom: "12px", alignItems: "flex-start" }}>
      {!isMobile && (
        <div
          style={{
            width: "32px",
            height: "32px",
            borderRadius: "50%",
            backgroundColor: "#825ee7",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            marginTop: "2px",
          }}
        >
          <SmartToyOutlinedIcon style={{ fontSize: "18px", color: "#fff" }} />
        </div>
      )}
      <div>
        <div
          style={{
            maxWidth: isMobile ? "90%" : "75%",
            padding: "10px 16px",
            borderRadius: "4px 16px 16px 16px",
            backgroundColor: "#fff",
            border: "1px solid #e8e8e8",
            fontSize: "14px",
            lineHeight: 1.5,
            color: "#333",
          }}
        >
          {text && <MarkdownRenderer content={text} />}
          <ToolCallDisplay toolCalls={toolCalls} />
        </div>
        {onFeedback && (
          <div style={{ display: "flex", gap: "4px", marginTop: "4px" }}>
            <button
              onClick={() => onFeedback(feedback === "up" ? null : "up")}
              title="Thumbs up"
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: "4px",
                borderRadius: "4px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <ThumbUp
                style={{
                  fontSize: "16px",
                  color: feedback === "up" ? "#825ee7" : "#999",
                }}
              />
            </button>
            <button
              onClick={() => onFeedback(feedback === "down" ? null : "down")}
              title="Thumbs down"
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: "4px",
                borderRadius: "4px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <ThumbDown
                style={{
                  fontSize: "16px",
                  color: feedback === "down" ? "#dc2626" : "#999",
                }}
              />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AssistantMessageBubble;
